import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Dashboard from '@/components/Dashboard'
import Admin from '@/components/Admin'
import Sku from '@/components/Sku'
import Catalog from '@/components/Catalog'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      children: [
        {
          path: '/admin',
          name: 'admin',
          component: Admin,
        },
        {
          path: '/sku',
          name: 'sku',
          component: Sku,
        },
        {
          path: '/catalog',
          name: 'catalog',
          component: Catalog,
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js